import { Caption, css, PlusIcon, styled } from 'canoe';

export const AddOptionLabel = styled(Caption)`
  ${({ theme }) => css`
    color: ${theme.colors.OnyxGray};
    text-decoration: underline;
    margin-left: ${theme.spaces.xxs};
  `}
`;
export const AddOptionIcon = styled(PlusIcon)``;
export const AddOptionWrapper = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    padding: 0;
    margin-top: ${theme.spaces.xs};
    border: none;
    background: none;
    border-radius: ${theme.borderRadius.small};
    box-shadow: none;
    cursor: pointer;

    &:focus,
    &:hover,
    &:active {
      outline: 0 none;
    }

    &:hover {
      ${AddOptionLabel} {
        color: ${theme.colors.OnyxGrayD10};
      }

      ${AddOptionIcon} svg > * {
        fill: ${theme.colors.OnyxGrayD10};
      }
    }
  `}
`;
